// extracted by mini-css-extract-plugin
module.exports = {"comments":"bj_fw","comments__list":"bj_fx"};